import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useParams } from 'react-router-dom';

interface NavLinkProps {
  to: string;
  label: string;
}
const activeClasses =
  'flex items-center h-full text-body1 font-bd text-primary-green	navLinkShadow';

const inactiveClasses = 'flex items-center h-full text-body1';

const NavigationLink = (props: NavLinkProps) => {
  const { t } = useTranslation();
  const { to, label } = props;

  const { retailerId } = useParams();

  // Check if the to prop contains :retailerId and replace it with actual retailerId if it exists
  const resolvedTo =
    retailerId && to.includes(':retailerId')
      ? to.replace(':retailerId', retailerId)
      : to;

  return (
    <NavLink
      to={resolvedTo}
      className={({ isActive }) => (isActive ? activeClasses : inactiveClasses)}
    >
      {t(`navigation.${label}` as any)}
    </NavLink>
  );
};

export default NavigationLink;
